// extracted by mini-css-extract-plugin
export default {"categoryNavContent":"views-ProductlistPage-themes-PP-styles__categoryNavContent--Ekepm"};